import React from 'react';
import "../styles/loading.scss";

export default function Loading() {
    return(
        <div id='loading-bar'>
            <div id='barra-animada'/>
        </div>
    )
};